import { gql, TypedDocumentNode } from '@apollo/client';

export const GET_ORGANISATION_PUBLIC_CONTACT_DETAILS: TypedDocumentNode<
  { data: { publicEmail?: string; publicPhoneNumber?: string } },
  { organisationId: string }
> = gql`
  query getOrganisationPublicContactDetails($organisationId: UUID!) {
    data: getOrganisationPublicContactDetails(id: $organisationId) {
      publicEmail
      publicPhoneNumber
    }
  }
`;
